import React from 'react';

interface InstagramIconProps {
  className?: string;
}

const InstagramIcon: React.FC<InstagramIconProps> = ({ className }) => (
  <i
    className={['fa-brands fa-instagram', className].filter(Boolean).join(' ')}
    aria-hidden="true"
  />
);

export default InstagramIcon;
